export enum WolandErrorCodesEnum {
    None = -1,
    //Common
    Unknown = 0,
    Validation = 1,
    Unauthorized = 3,
    TemplateNotAssign = 10,
    TemplateUsedForExam = 11,
    TokenIsNull = 20,
    OneDriveTokenExpired = 28,
    ExamNotFound = 30,
    ExamNameIsExist = 31,
    SlotIsUsing = 32,
}
